import { Tooltip } from 'antd';
import React, { useState, useRef, useEffect } from 'react';

type props = {
    content: string;
    maxLine?: number;
};

export const TooltipText = ({ content, maxLine = 1 }: props) => {
    const refText: any = useRef(null);

    return (
        // <Tooltip title={content} color={'#ffffff'}>
            <span ref={refText} className={maxLine == 1 ? "tooltip-text" : "tooltip-text-multiline"} style={{WebkitLineClamp: maxLine}}>
                {content}
            </span>
        // </Tooltip>
    );
};
